import "babel-polyfill";
import 'url-search-params-polyfill';

window._ = require('lodash');

window.queryString = require('query-string');

window.$ = window.jQuery = require('jquery');

window.Cookies = require('js-cookie');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

import Vue from 'vue';
window.Vue = Vue;

import VueLocalStorage from 'vue-localstorage';
Vue.use(VueLocalStorage);

import Helper from './src/core/Helper';
window.Helper = Helper;

import Reporter from './src/core/Reporter';
window.Reporter = new Reporter;

import EventHandler from './src/core/EventHandler';
window.EventHandler = new EventHandler;

import ViewPort from './src/core/ViewPort';
window.ViewPort = new ViewPort;
